import { useTranslation } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { MenuBadge } from "@impero-com/ui";
import { Spin } from "antd";

import { usePendingWorkQueueRows } from "org/dashboardPendingActivities/hooks/usePendingWorkQueueRows";
import { PendingActivityTableRow } from "org/dashboardPendingActivities/types";
import { usePendingActivitiesCount } from "org/dashboardPendingActivities/usePendingActivitiesCount";

import * as theme from "./MenuBadgeWrapper.css";

export function MenuBadgeWrapper() {
    const { t } = useTranslation();
    const pendingWorkQueue = usePendingWorkQueueRows();
    const label = t("Dashboard_PendingActions_Title");

    switch (pendingWorkQueue.status) {
        case "pending":
            return (
                <span className={theme.pendingLabel}>
                    {label}
                    <Spin size="small" />
                </span>
            );
        case "error":
            // The count only decorates a tab on another page, so a failed fetch leaves the label
            return <>{label}</>;
        case "success":
            return (
                <PendingActionsBadge rows={pendingWorkQueue.rows}>
                    {label}
                </PendingActionsBadge>
            );
        default:
            return assertNever(pendingWorkQueue);
    }
}

function PendingActionsBadge({
    rows,
    children,
}: {
    rows: PendingActivityTableRow[];
    children: string;
}) {
    const { count, isOverdue } = usePendingActivitiesCount(rows);

    return (
        <MenuBadge count={count} hasOverdueActions={isOverdue}>
            {children}
        </MenuBadge>
    );
}
